// extracted by mini-css-extract-plugin
module.exports = {"in-progress":"InProgress_in-progress__2dWS5"};